import { gql } from '@apollo/client';

export const SLUG_ALIAS_RESOLUTION = gql`
  query SlugAliasResolution($slug: String!) {
    routeBySlugAlias(pSlug: $slug) {
      slug
      territory {
        slug
      }
      routeManagers {
        nodes {
          community {
            slug
          }
        }
      }
    }
    eventCourseBySlugAlias(pSlug: $slug) {
      slug
      isCourse
      isProduct
      communityByOrganizerCommunity {
        slug
      }
    }
  }
`;
